import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询已办服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStaffFinishServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/queryStaffFinishServ',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 关闭订单
 * @param {Object} data 订单数据
 * @returns {Promise} Promise对象
 */
export function closeOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/myHousekeepingDispatch.closeOrder',
      method: 'post',
      data,
      emulateJSON: true
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}